module.exports = __webpack_public_path__ + "static/founder-42e5cfb8feeaaa79aafc275f2029ac00.jpg";